<template
  ><div>
    <v-dialog persistent v-model="MEContactMappingDialog" max-width="700">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0 pb-2"
          >Rows ({{ manageEngineUsersContactMapping.length }})
          <small class="text--secondary ml-3"
            >Search by Ctrl+F</small
          ></v-card-title
        >
        <strong>
          Map extensions or phone numbers to ManageEngine emails or user IDs.
          Existing mappings are shown below.
        </strong>
        <br />
        <v-btn small color="success" @click="openMapPhoneDialog"
          >Map Phone</v-btn
        >
        <v-btn small color="success" @click="openMapExtDialog"
          >Map Extension</v-btn
        >
        <v-layout row justify-start>
          <div class="pt-1 font-weight-medium width-220">
            Local Mapping
          </div>
          <div class="pt-1 font-weight-medium width-220">
            ManageEngine User Info
          </div>
          <v-spacer></v-spacer>
        </v-layout>
        <v-divider class="my-2"></v-divider>
        <div style="overflow-y: auto; height: 400px">
          <div
            v-for="(manageengineContact,
            index) in manageEngineUsersContactMapping"
          >
            <v-layout row justify-start>
              <div class="pt-1 width-220">
                <strong> Extension:</strong>
                {{ manageengineContact.extension }}
                <v-btn
                  aria-label
                  v-if="manageengineContact.extension"
                  @click="
                    extensionToDelete = manageengineContact.extension;
                    openConfirmDeleteExtDialog();
                  "
                  icon
                  density="compact"
                  class="ma-0 pa-0"
                  style="height: 25px; width: 25px;"
                >
                  <v-icon color="grey darken-1" size="16">mdi-delete</v-icon>
                </v-btn>
                <br />
                <strong> Phone:</strong>
                {{ manageengineContact.phone }}
                <v-btn
                  aria-label
                  v-if="manageengineContact.phone"
                  @click="
                    phoneToDelete = manageengineContact.phone;
                    openConfirmDeletePhoneDialog();
                  "
                  icon
                  density="compact"
                  class="ma-0 pa-0"
                  style="height: 25px; width: 25px;"
                >
                  <v-icon color="grey darken-1" size="16">mdi-delete</v-icon>
                </v-btn>
              </div>
              <div class="pt-3 width-320">
                <strong v-if="manageengineContact.manageengineEmail">
                  Email:
                </strong>
                {{ manageengineContact.manageengineEmail }}
                <strong v-if="manageengineContact.manageengineUserID">
                  User ID:
                </strong>
                {{ manageengineContact.manageengineUserID }}
              </div>
              <v-spacer></v-spacer>
            </v-layout>
            <v-divider
              class="my-2"
              v-if="index + 1 < manageEngineUsersContactMapping.length"
            ></v-divider>
          </div>
        </div>

        <v-card-actions class="mr-0 mt-3 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="MEContactMappingDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="mapExtDialog" max-width="350">
      <v-card class="pa-4">
        <v-form ref="extForm">
          <v-layout row>
            <v-card-title class="headline pl-0 pt-0 pb-2"
              >Map Extension {{ selectedExt }}</v-card-title
            >
          </v-layout>
          <v-text-field
            v-model="selectedExt"
            label="Extension"
            placeholder="Enter a 5-digit number"
            outlined
            style="flex: 1;"
            :rules="[rules.extension]"
          />
          <v-select
            v-model="extMapSelection"
            label="Map extension by"
            :items="['Email', 'User ID']"
            @change="
              (selectedEmailForExtSet = ''), (selecteduserIDForExtSet = '')
            "
          ></v-select>
          <v-text-field
            v-if="extMapSelection === 'Email'"
            v-model="selectedEmailForExtSet"
            label="Email"
            placeholder="Enter a full valid ManageEngine Email"
            outlined
            :rules="[rules.optionalEmail]"
          />
          <v-text-field
            v-if="extMapSelection === 'User ID'"
            v-model="selecteduserIDForExtSet"
            label="User ID"
            placeholder="Enter a valid ManageEngine User ID"
            outlined
            :rules="[rules.userID]"
            ><template v-slot:prepend>
              <v-icon
                color="red"
                class="cursor-pointer blink"
                @click="showIDAlert()"
              >
                mdi-exclamation
              </v-icon>
            </template></v-text-field
          >
          <p
            v-if="
              this.selectedExt &&
                (this.selectedEmailForExtSet || this.selecteduserIDForExtSet)
            "
            class="font-weight-bold"
            style="font-size: 0.75rem;"
          >
            {{ `Extension "${this.selectedExt}"` }}
            will mapped to
            {{ this.selectedEmailForExtSet ? "email" : "User ID" }}
            "{{ this.selectedEmailForExtSet }}
            {{ this.selecteduserIDForExtSet }}"
          </p>
          <v-card-actions class="mr-0 ml-0 mt-0 pb-0">
            <v-spacer></v-spacer>
            <v-btn color="default" dark @click="resetMapExtension()">
              cancel
            </v-btn>
            <v-btn
              :loading="processing"
              :disabled="
                !this.selectedEmailForExtSet && !this.selecteduserIDForExtSet
              "
              color="success"
              @click="saveExtension()"
            >
              save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="alertExistExtDialog" max-width="300">
      <v-card class="pa-3">
        <div class="font-weight-medium">
          Extension {{ this.selectedExt }} Already matched !
        </div>

        <v-card-actions class="mr-0 mt-3 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="success" dark @click="alertExistExtDialog = false"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="confirmDeleteExtDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Delete Extension</v-card-title>

        <div class="font-weight-medium">
          Extension {{ extensionToDelete }} will be deleted
        </div>

        <v-card-actions class="mr-0 mt-3 pb-0">
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            dark
            @click="
              extensionToDelete = '';
              confirmDeleteExtDialog = false;
            "
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="updateExtension()"
          >
            delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="mapPhoneDialog" max-width="350">
      <v-card class="pa-4">
        <v-form ref="phoneForm">
          <v-layout row>
            <v-card-title class="headline pl-0 pt-0 pb-2"
              >Map Phone {{ selectedPhone }}</v-card-title
            >
          </v-layout>
          <v-text-field
            v-model="selectedPhone"
            label="Phone"
            placeholder="Enter a 10-digit number"
            outlined
            style="flex: 1;"
            :rules="[rules.phone]"
          />
          <v-select
            v-model="phoneMapSelection"
            label="Map phone by"
            :items="['Email', 'User ID']"
            @change="
              (selectedEmailForPhoneSet = ''), (selecteduserIDForPhoneSet = '')
            "
          ></v-select>
          <v-text-field
            v-if="phoneMapSelection === 'Email'"
            v-model="selectedUserNameForPhoneSet"
            label="Email/Username"
            placeholder="Enter a full valid ManageEngine username/email"
            outlined
            :rules="[rules.optionalEmail]"
          />
          <v-text-field
            v-if="phoneMapSelection === 'User ID'"
            v-model="selecteduserIDForPhoneSet"
            label="User ID"
            placeholder="Enter a valid ManageEngine User ID"
            outlined
            :rules="[rules.userID]"
            ><template v-slot:prepend>
              <v-icon
                color="red"
                class="cursor-pointer blink"
                @click="showIDAlert()"
              >
                mdi-exclamation
              </v-icon>
            </template></v-text-field
          >
          <p
            v-if="
              this.selectedPhone &&
                (this.selectedEmailForPhoneSet ||
                  this.selecteduserIDForPhoneSet)
            "
            class="font-weight-bold"
            style="font-size: 0.75rem;"
          >
            {{ `Phone "${this.selectedPhone}"` }}
            will mapped to
            {{ this.selectedEmailForPhoneSet ? "email" : "User ID" }}
            "{{ this.selectedEmailForPhoneSet }}
            {{ this.selecteduserIDForPhoneSet }}"
          </p>
          <v-card-actions class="mr-0 mt-3 ml-0 pb-0">
            <v-spacer></v-spacer>

            <v-btn color="default" dark @click="resetMapPhone()">Cancel</v-btn>
            <v-btn :loading="processing" color="success" @click="savePhone()">
              save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="alertExistPhoneDialog" max-width="310">
      <v-card class="pa-3">
        <div class="font-weight-medium">
          Phone {{ this.selectedPhone }} Already matched !
        </div>

        <v-card-actions class="mr-0 mt-3 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="success" dark @click="alertExistPhoneDialog = false"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="confirmDeletePhoneDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">Delete Phone</v-card-title>

        <div class="font-weight-medium">
          Phone {{ phoneToDelete }} will be deleted
        </div>

        <v-card-actions class="mr-0 mt-3 pb-0">
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            dark
            @click="
              phoneoDelete = '';
              confirmDeletePhoneDialog = false;
            "
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="updatePhone()">
            delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="IDAlertDialog" max-width="600">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0">
          Map User ID Alert
        </v-card-title>
        <strong>
          The best way to map is by email. Use this option only when there is no
          requester email.
          <br />
        </strong>
        <v-card-text>
          To map by ID, make sure you are using the correct ID.<br />
          Open the ticket on
          <a href="https://utaw.sdpondemand.manageengine.com" target="_blank"
            >utaw.sdpondemand.manageengine.com</a
          >.<br />
          Open the browser console (F12 → Console) and run:<br />
          <code
            >document.querySelector('.requester-link-card').querySelector('a').getAttribute('onclick').split(`'`)[1] </code
          ><br />
          <br />
          Optional: Create a bookmarklet with:<br />
          <code
            >javascript:(function(){alert(document.querySelector('.requester-link-card').querySelector('a').getAttribute('onclick').split(`'`)[1]);})();</code
          ><br />
          Than when you on a ticket Click the bookmark to see the requester ID.
        </v-card-text>

        <v-card-actions class="mr-0 mt-3 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="success" dark @click="IDAlertDialog = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div></template
>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.MEContactMappingDialog = val;
      },
    },
    MEContactMappingDialog(val) {
      this.$emit("input", val);
      if (val === true) {
        this.loadManageEngineUsersContactMapping();
      }
    },
  },
  data: () => ({
    MEContactMappingDialog: false,

    mapExtDialog: false,
    selectedExt: "",
    selectedEmailForExtSet: "",
    alertExistExtDialog: false,
    confirmDeleteExtDialog: false,
    extensionToDelete: "",
    newExtension: "",
    extMapSelection: "Email",
    selecteduserIDForExtSet: "",

    mapPhoneDialog: false,
    selectedPhone: "",
    selectedUserNameForPhoneSet: "",
    alertExistPhoneDialog: false,
    confirmDeletePhoneDialog: false,
    phoneToDelete: "",
    newPhone: "",
    phoneMapSelection: "Email",
    selecteduserIDForPhoneSet: "",

    IDAlertDialog: false,

    manageEngineUsersContactMapping: [],
    processing: false,

    rules: {
      required: (value) => !!value || "Required.",
      email: (v) =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "Enter a valid email",
      optionalEmail: (value) => {
        if (!value) return true;
        return (
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            value
          ) || "Enter a valid email or remove."
        );
      },
      extension: (v) => /^\d{5}$/.test(v) || "Enter a valid extension",
      phone: (v) =>
        /^\d{10}$/.test(v) ||
        "Enter a valid phone without dashes or parentheses",
      userID: (value) => {
        if (!value) return true;
        return (
          /^\d{17}$/.test(value) ||
          "Enter a valid manageengine user ID or remove."
        );
      },
    },
  }),

  methods: {
    async openManageEngineUsersContactMappingDialog() {
      this.MEContactMappingDialog = true;
    },

    async loadManageEngineUsersContactMapping() {
      const response = await this.$http.get(
        "api/manageengine/getManageEngineUsersContactMapping"
      );
      this.manageEngineUsersContactMapping = response.map((user) => {
        user.selected = false;
        return user;
      });
    },
    openConfirmDeleteExtDialog() {
      this.confirmDeleteExtDialog = true;
    },
    async openMapExtDialog() {
      this.mapExtDialog = true;
    },
    openConfirmDeletePhoneDialog() {
      this.confirmDeletePhoneDialog = true;
    },
    async openMapPhoneDialog() {
      this.mapPhoneDialog = true;
    },
    async updateExtension() {
      try {
        this.processing = true;
        await this.$http.put(
          `api/manageengine/UpdateManageengineExtension?extension=${
            this.extensionToDelete
          }&newExtension=${this.newExtension}`
        );
        this.processing = false;
        this.confirmDeleteExtDialog = false;
        this.loadManageEngineUsersContactMapping();
        this.$notify({
          group: "notification",
          text: "Extension Deleted",
          type: "success",
        });
        this.extensionToDelete = "";
      } catch (e) {
        this.processing = false;
      }
    },

    async saveExtension() {
      if (!this.$refs.extForm.validate(true)) {
        return;
      }
      await this.loadManageEngineUsersContactMapping();
      const extensions = this.manageEngineUsersContactMapping.map((u) => {
        return u.extension;
      });
      if (extensions.find((element) => element == this.selectedExt)) {
        this.alertExistExtDialog = true;
        return;
      }
      try {
        this.processing = true;
        const response = await this.$http.post(
          `api/manageengine/SaveManageengineExt?extension=${
            this.selectedExt
          }&usernameEmail=${this.selectedEmailForExtSet}&userID=${
            this.selecteduserIDForExtSet
          }`
        );
        await this.loadManageEngineUsersContactMapping();
        this.resetMapExtension();
        this.$notify({
          group: "notification",
          text: "Map Extension Saved",
          type: "success",
        });
      } catch (e) {}
    },
    resetMapExtension() {
      this.processing = false;
      this.mapExtDialog = false;
      this.selectedExt = "";
      this.selectedEmailForExtSet = "";
      this.$refs.extForm.resetValidation(true);
      this.selecteduserIDForExtSet = "";
      this.extMapSelection = "Email";
    },
    async updatePhone() {
      try {
        this.processing = true;
        await this.$http.put(
          `api/manageengine/UpdateManageenginePhone?phone=${
            this.phoneToDelete
          }&newphone=${this.newPhone}`
        );
        this.processing = false;
        this.confirmDeletePhoneDialog = false;
        this.loadManageEngineUsersContactMapping();
        this.$notify({
          group: "notification",
          text: "Phone Deleted",
          type: "success",
        });
        this.phoneToDelete = "";
      } catch (e) {
        this.processing = false;
      }
    },
    async savePhone() {
      if (!this.$refs.phoneForm.validate(true)) {
        return;
      }
      await this.loadManageEngineUsersContactMapping();
      const phones = this.manageEngineUsersContactMapping.map((u) => {
        return u.phone;
      });
      if (phones.find((element) => element == this.selectedPhone)) {
        this.alertExistPhoneDialog = true;
        return;
      }
      try {
        this.processing = true;
        const response = await this.$http.post(
          `api/manageengine/SaveManageenginePhone?phone=${
            this.selectedPhone
          }&usernameEmail=${this.selectedUserNameForPhoneSet}&userID=${
            this.selecteduserIDForPhoneSet
          }`
        );
        await this.loadManageEngineUsersContactMapping();
        this.resetMapPhone();
        this.$notify({
          group: "notification",
          text: "Map Phone Saved",
          type: "success",
        });
      } catch (e) {}
    },
    resetMapPhone() {
      this.processing = false;
      this.mapPhoneDialog = false;
      this.selectedPhone = "";
      this.selectedUserNameForPhoneSet = "";
      this.$refs.phoneForm.resetValidation(true);
      this.selecteduserIDForPhoneSet = "";
      this.phoneMapSelection = "Email";
    },
    showIDAlert() {
      this.IDAlertDialog = true;
    },
  },
};
</script>
<style scoped>
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1.5s infinite;
}
</style>
